import { IsNotEmpty, IsNumber } from 'class-validator';

export class BatchDownloadDto {
  @IsNotEmpty()
  @IsNumber()
  download_id: string;
}
